import { isRecord } from '@/helpers/isRecord'
import { FetchResourceOK } from '@/japi/types/FetchResourceOK'
import { Resource } from '@/japi/types/Resource'

import { isErrorDocument } from './isErrorDocument'

export const isResourceDocument = <R extends Resource>(japiDocument: unknown): japiDocument is FetchResourceOK<R> => isRecord(japiDocument) && ! isErrorDocument(japiDocument) && 'data' in japiDocument && (japiDocument.data === null || (isRecord(japiDocument.data) && typeof japiDocument.data.type === 'string'))
